import * as _ from 'lodash'
import {MessageType} from "../PA.Core/PA.Core.IF.Basic";
import {BusinessUnitBO} from "./BusinessUnitBO";

export class BusinessUnitBOValidation {

    static async ValidateFields(aBO: BusinessUnitBO): Promise<void> {

        const self = this;

        //validate WB_BusinessUnit_ID_Prnt
        if(_.isEqual(aBO.WB_BusinessUnit.cif.WB_BUSINESSUNIT_ID.toString(), aBO.WB_BusinessUnit.cif.WB_BUSINESSUNIT_ID_PRNT.toString())) {
            self.addMessage(aBO, "mtchIDs", "WB_BUSINESSUNIT_ID_PRNT cannot be equal to WB_BUSINESSUNIT_ID")
        } else {
            aBO.ValidateMessageProvider.removeMessage('mtchIDs')
        }

        //validate benchmark start and end dates
        let benchmarkIds: any = []
        let fiscalYear:number = new Date().getFullYear()
        let fiscalYearMatch:boolean = false
        let benchmarkValue:boolean = false
        let emptyDate:boolean = false
        _.forEach(aBO.WB_BusinessUnit.WB_BenchmarkRows, (benchmarkRow) => {
            let startDate = Number((benchmarkRow.cif.EFFECTIVE_START_DT).substring(0,4))
            let endDate = Number((benchmarkRow.cif.EFFECTIVE_END_DT).substring(0,4))
            let highBenchmark = _.toNumber(benchmarkRow.cif.MAX_THRESHOLD)
            let lowBenchmark = _.toNumber(benchmarkRow.cif.MIN_THRESHOLD)

            if(!(_.isEqual(fiscalYear, startDate) && _.isEqual(fiscalYear, endDate))){
                fiscalYearMatch = true
            }

            if (_.gt(lowBenchmark,highBenchmark)) {
                benchmarkValue = true
            }

            if (_.isEmpty(benchmarkRow.cif.EFFECTIVE_START_DT) && _.isEmpty(benchmarkRow.cif.EFFECTIVE_END_DT) ) {
                emptyDate = true
            }

        })

        // if(emptyDate){
        //     // Log Message
        //     aBO.ValidateMessageProvider.addMessage(
        //         {
        //             code: 'emptyDate',
        //             type: MessageType.Error,
        //             title: `Start/End dates cannot be empty`,
        //             description: "",
        //             subtitle: "",
        //             count: 0
        //         })
        //
        // } else {
        //     aBO.ValidateMessageProvider.removeMessage('emptyDate')
        //
        // }
        if(benchmarkValue){
            // Log Message
            aBO.ValidateMessageProvider.addMessage(
                {
                    code: 'benchmarkValue',
                    type: MessageType.Error,
                    title: `Low benchmark should be less than high benchmark value`,
                    description: "",
                    subtitle: "",
                    count: 0
                })

        } else {
            aBO.ValidateMessageProvider.removeMessage('benchmarkValue')

        }

        // if(fiscalYearMatch){
        //     // Log Message
        //     aBO.ValidateMessageProvider.addMessage(
        //         {
        //             code: 'fiscalYearMatch',
        //             type: MessageType.Error,
        //             title: `Effective start/end dates must be in current fiscal year`,
        //             description: "",
        //             subtitle: "",
        //             count: 0
        //         })
        //
        // } else {
        //     aBO.ValidateMessageProvider.removeMessage('fiscalYearMatch')
        //
        // }
    }

    private static addMessage(aBO: BusinessUnitBO, code: string, message: string): void {
        aBO.ValidateMessageProvider.addMessage(
            {
                code: code,
                type: MessageType.Error,
                title: message,
                description: "",
                subtitle: "",
                count: 0
            });
    }
}